import React from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { HiComputerDesktop } from 'react-icons/hi2';
import { IoFileTrayStackedSharp } from "react-icons/io5";
import { GiStopwatch } from "react-icons/gi";
import { MdAttachMoney } from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import { apiService } from '../Config/api.service';
import { HomeIcon, SettingIcon, PeopleIcon, MoneyIcon, DocIcon, Doc2Icon, LeaveIcon, StateIcon } from '../Tools/IconSvg';

const MenuNav = React.memo(({ isCollapsed, onLogoutRequest }) => {
    const handleLogoutRequest = () => {
        onLogoutRequest();
    };

    const activeClass =
        'bg-[--bg-color] text-[--color-primary] border-[--color-primary] [&_svg]:text-[--color-primary]';

    const inactiveClass = 'text-[--bg-color]';
    const hoverClass = 'hover:bg-[--bg-hover]  hover:border-[--color-primary]';

    const menuItems = [
        { path: '/', label: 'Tableau de Bord', icon: <HomeIcon className="w-6 h-6" /> },
        { path: '/employees', label: 'Mes Collaborateurs', icon: <PeopleIcon className="w-6 h-6" /> },
        { path: '/primes', label: 'Éléments de renumerations', icon: <MoneyIcon className="w-6 h-6" /> },
        { path: '/payslip/report', label: 'Bulletin de Paie', icon: <Doc2Icon className="w-6 h-6" /> },
        { path: '/leave', label: 'Présences & Suivi activités', icon: <LeaveIcon className="w-6 h-6" /> },
        { path: '/etats', label: 'Etats ', icon: <StateIcon className="w-6 h-6" /> },
    ];

    return (
        <div className="flex flex-col font-semibold justify-between h-full text-white py-4">
            <ul className="space-y-4">
                {menuItems.map((item, index) =>
                    item.subItems ? (
                        <li key={index}>
                            <div className="group">
                                <div className={`flex items-center gap-2 py-2 ${isCollapsed ? 'pl-3 justify-center' : 'pl-6'} cursor-pointer`}>
                                    {item.icon} {!isCollapsed && item.label}
                                </div>
                                {!isCollapsed && (
                                    <ul className="ml-4 space-y-2">
                                        {item.subItems.map((subItem, subIndex) => (
                                            <li key={subIndex}>
                                                <NavLink
                                                    to={subItem.path}
                                                    className={({ isActive }) =>
                                                        `flex items-center gap-2 py-2 ${hoverClass} ${isActive ? activeClass : inactiveClass}`
                                                    }
                                                    aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
                                                >
                                                    {({ isActive }) => (
                                                        <>
                                                            {isActive && (
                                                                <div className='border-left border-[3px] h-[30px] justify-start rounded-lg border-orange-400'></div>
                                                            )}
                                                            <div className='flex items-center gap-2 pl-6'>
                                                                {subItem.icon} {subItem.label}
                                                            </div>
                                                        </>
                                                    )}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </li>
                    ) : (
                        <li key={index}>
                            <NavLink
                                to={item.path}
                                className={({ isActive }) => 
                                    `flex w-full py-2 ${!isActive && hoverClass} ${isActive ? activeClass : inactiveClass} ${isCollapsed ? 'justify-center relative' : ''}`
                                }
                                aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
                                title={isCollapsed ? item.label : ""}
                            >
                                {({ isActive }) => (
                                    <>
                                        {isActive && !isCollapsed && (
                                            <div className='border-[3px] h-[30px] justify-start rounded-lg border-orange-400'></div>
                                        )}
                                        {isActive && isCollapsed && (
                                            <div className='absolute left-0 top-1/2 -translate-y-1/2 border-[3px] h-[30px] rounded-lg border-orange-400'></div>
                                        )}
                                        <div className={`flex items-center gap-2 ${isCollapsed ? 'pl-0 justify-center' : 'pl-4'}`}>
                                            {item.icon} {!isCollapsed && item.label}
                                        </div>
                                    </>
                                )}
                            </NavLink>
                        </li>
                    )
                )}
            </ul>
            <div className={`mt-6 border-t pt-4 ${isCollapsed ? 'text-center' : ''}`}>
                <ul className="space-y-2">
                    <li>
                        <a
                            href="https://yros.io/simulateur/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`flex items-center gap-2 py-2 ${isCollapsed ? 'justify-center' : 'pl-5'} rounded-md text-white`}
                            title={isCollapsed ? "Simulateur en ligne" : "Simulateur en ligne (nouvel onglet)"}
                            aria-label="Simulateur en ligne (ouvre un nouvel onglet)"
                        >
                            <HiComputerDesktop  className="w-6 h-6" />
                            {!isCollapsed && (
                                <span className="flex items-center gap-1">
                                    Simulateur en ligne
                                </span>
                            )}
                        </a>
                    </li>
                    <li>
                        <NavLink
                            to="/settings"
                            className={({ isActive }) => 
                                `flex items-center gap-2 py-2 ${isCollapsed ? 'justify-center relative' : 'pl-5'} rounded-md text-white`
                            }
                            aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
                            title={isCollapsed ? "Paramètres" : ""}
                        >
                            {({ isActive }) => (
                                <>
                                    {isActive && isCollapsed && (
                                        <div className='absolute left-0 top-1/2 -translate-y-1/2 border-[3px] h-[30px] rounded-lg border-orange-400'></div>
                                    )}
                                    <div className="flex items-center gap-2">
                                        <SettingIcon className="w-6 h-6" />
                                        {!isCollapsed && "Paramètres"}
                                    </div>
                                </>
                            )}
                        </NavLink>
                    </li>
                    <li>
                        <button
                            onClick={handleLogoutRequest}
                            className={`flex items-center gap-2 py-2 ${isCollapsed ? 'justify-center w-full' : 'pl-6'} rounded-md text-white`}
                            title={isCollapsed ? "Déconnexion" : ""}
                        >
                            <FaSignOutAlt className="text-white" /> {!isCollapsed && "Déconnexion"}
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
});

export default MenuNav;